module.exports = function (analyticsPageName) {
  // Setup error notifications before doing anything else
  const airbrake = require('client/lib/airbrake')
  airbrake.configure()
  airbrake.attachBuildNumber(wiggin.buildNumber)

  const qs = require('qs')
  const Emitter = require('client/lib/emitter')
  const Session = require('client/lib/sess')
  const { openWindow } = require('client/lib/window')
  const Analytics = require('client/lib/analytics')
  const { track } = Analytics

  const params = qs.parse(window.location.search.replace(/^\?/, ''))
  const targetDomain = params.proto + params.host

  const app = window.app = new Emitter()

  if (wiggin.user.loggedIn) {
    // Segment.identify & Branch.setIdentity cannot be called for logged out users
    // since the anonymous ID is reset on the next identify/register call
    Analytics.segmentIdentify(wiggin.user)
    Analytics.branchIdentify(wiggin.user)
  }

  if (!wiggin.user.bot) {
    window.analytics.page()
  }

  app.on('should-close-modal', function () {
    window.parent.postMessage('close-mix-dialog', targetDomain)
  })

  const state = {}
  app.state = function (name, value) {
    if (value === undefined) {
      return name === value ? state : state[name]
    }
    state[name] = value
  }

  app.state('page', analyticsPageName)

  app.sess = new Session(wiggin.user)

  track('pageview')

  require('client/actions')({
    'close-dialog': function () {
      app.trigger('should-close-modal')
    },
    'close-toast': function () {
      app.trigger('should-close-modal')
    },
    'add-url-retry': function () {
      window.location.reload()
    },
    'stop-propagation': function (e) {
      if (e.isImmediatePropagationStopped()) {
        return
      }
      e.stopPropagation()
      e.stopImmediatePropagation()
    },
    'open-website': function (e) {
      e.preventDefault()
      const $article = $(this).closest('[data-body]')
      const article = JSON.parse($article.attr('data-body'))
      track('show-web-content', {
        url: article.url,
        hostname: article.hostname,
        metabase: {
          'actioned_object_type': 'url_id',
          'actioned_object_id': article['url_id']
        }
      })
      openWindow(article.url)
    }
  })

  require('client/components/mix-select-form')

  $('.mix-select__form').MixSelectForm({
    submitCallback: () => app.trigger('should-close-modal')
  })
}
